module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/EDUCATION-fe92c6ec3b3c664e31be4db2d9b3d641.png";